/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import {Component} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {FloatButtonCartService} from './floatButtonCart.service';

@Component({
  selector: 'float-button-cart', // <my-app></my-app>
  template: require('./floatButtonCart.html'),
  styles: [require('./floatButtonCart.scss')]
})

export class FloatButtonCart {

  public count: number = 0;
  subscription: Subscription;

  constructor(private _floatService: FloatButtonCartService) {
    if (localStorage.getItem('carrito')) {
      let array = JSON.parse(localStorage.getItem('carrito'));
      this.count = 0;
      for (let index in array) {
        this.count = this.count+parseInt(array[index]);
      }

    }
    else {
      localStorage.setItem('carrito', JSON.stringify({}))
    }
    this.subscription = this._floatService.getUpdate().subscribe(emit => {
      if (emit) {
        if (localStorage.getItem('carrito')) {
          let array = JSON.parse(localStorage.getItem('carrito'));
          this.count = 0;
          for (let index in array) {
            this.count = this.count+parseInt(array[index]);
          }
        }
        else {
          localStorage.setItem('carrito', JSON.stringify({}));
          this.count = 0;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/floatButtonCart/floatButtonCart.component.ts